import React from "react";
import Card from "./Card/Card";
import "./styles.css";
import { foodList } from "../data/foodList";
import { restaurantList } from "../data/restaurant";

const Contents = () => {
  return (
    <div className="contents">
      {foodList
        .sort(() => Math.random() - 0.5)
        .map((food) => (
          <Card
            food={food}
            restaurant={restaurantList.find((r) => r.id === food.restaurantId)}
          />
        ))}
    </div>
  );
};

export default Contents;
